import { OptionType } from '../../types/filters';

export const GenderOptions = [
  { label: 'filterGenderMale', value: 'm' },
  { label: 'filterGenderFemale', value: 'f' },
  { label: 'filterGenderNonBinary', value: 'o' },
  { label: 'filterGenderUnknown', value: 'n' },
  { label: 'NOT_DISCLOSED', value: 'NA' },
] as OptionType<string>[];

export const AgeOptions = [
  { label: '<20', value: '0-19' },
  { label: '20-29', value: '20-29' },
  { label: '30-39', value: '30-39' },
  { label: '40-49', value: '40-49' },
  { label: '50-59', value: '50-59' },
  { label: '>=60', value: '60-100' },
  { label: 'NOT_DISCLOSED', value: 'NA' },
] as OptionType<string>[];

export const MonthOffsets = [
  { label: 'Current Month', value: 0 },
  { label: 'Last 1 Month', value: 1 },
  { label: 'Last 3 Months', value: 3 },
  { label: 'Last 6 Months', value: 6 },
  { label: 'Last 9 Months', value: 9 },
  { label: 'Last 1 Year', value: 12 },
];
